import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "rounded-lg justify-space-between mb-4 pa-2 d-flex" }
const _hoisted_3 = { class: "d-flex align-center" }
const _hoisted_4 = { class: "text-white text-subtitle-2 font-weight-bold" }
const _hoisted_5 = { class: "font-weight-medium" }
const _hoisted_6 = { class: "text-caption text-medium-emphasis" }
const _hoisted_7 = { class: "text-body-2" }
const _hoisted_8 = { class: "text-body-2" }
const _hoisted_9 = { class: "font-weight-medium text-caption" }
const _hoisted_10 = { class: "text-caption" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "text-primary" }
const _hoisted_13 = { class: "text-secondary" }
const _hoisted_14 = {
  key: 1,
  class: "text-grey"
}
const _hoisted_15 = {
  key: 1,
  class: "text-grey"
}
const _hoisted_16 = {
  key: 1,
  class: "text-grey"
}
const _hoisted_17 = {
  key: 1,
  class: "text-grey"
}
const _hoisted_18 = { class: "font-weight-medium" }
const _hoisted_19 = { class: "d-flex gap-1" }
const _hoisted_20 = { class: "text-center pt-2" }
const _hoisted_21 = {
  class: "sticky-header bg-grey-lighten-4 d-flex justify-space-between align-center px-4 py-3",
  style: {"border-bottom":"1px solid #e0e0e0"}
}
const _hoisted_22 = { class: "text-h6 font-weight-medium" }
const _hoisted_23 = { class: "pa-6" }
const _hoisted_24 = { class: "metadata-content" }

import { ref, onMounted, computed } from 'vue'
import { useLocationsStore } from './store'
import { Locations } from './models/locations'


export default /*@__PURE__*/_defineComponent({
  __name: 'LocationsView',
  setup(__props) {

const locationsStore = useLocationsStore()
const loading = ref(false)
const metadataDialog = ref(false)
const selectedMetadata = ref('')
const activeEditLocation = ref(false)
const activeCreateNewLocation = ref(false)
const loadingCreateLocation = ref(false)
const loadingEditLocation = ref(false)
const searchLocations = ref('')
const page = ref(1)
const itemsPerPage = ref(10)
const formTouched = ref(false)
const formRef = ref()
const formValid = ref(false)

const headers = [
  { title: 'CÓDIGO', key: 'code' },
  { title: 'NOMBRE', key: 'name' },
  { title: 'NOMBRE EXTENDIDO', key: 'extendedName' },
  { title: 'DESCRIPCIÓN', key: 'description' },
  { title: 'TIPO DE USO', key: 'typeUse' },
  { title: 'UTM', key: 'utm' },
  { title: 'COORDENADAS', key: 'coordinates' },
  { title: 'ALTITUD', key: 'altitude' },
  { title: 'ID EMPRESA', key: 'companyId' },
  { title: 'UBICACIÓN PADRE', key: 'parentLocationId' },
  { title: 'METADATOS', key: 'metadata' },
  { title: 'CREADO EN', key: 'createdAt' },
  { title: 'CREADO POR', key: 'createdBy' },
  { title: 'ACCIONES', key: 'actions' },
]

const locationsList = computed(() => locationsStore.locations)

// ─── REFS: Location ──────────────────────────────────────────────────────────
const locations = ref<Locations[]>([])
const location = ref<Locations>(new Locations())

// ─── ALERTAS ───────────────────────────────────────────────────────────────
const activeAlert = ref(false)
const textAlert = ref('')
const colorAlert = ref<'error' | 'success' | 'info' | 'warning'>('error')

// ─── VALIDACIONES ──────────────────────────────────────────────────────────
const codeError = ref('')
const nameError = ref('')

// ─── COMPUTED ──────────────────────────────────────────────────────────────
const pageCount = computed(() => Math.ceil(locationsList.value.length / itemsPerPage.value))

// ─── FUNCIONES AUXILIARES ──────────────────────────────────────────────────
const resetForm = () => {
  location.value = new Locations()
  codeError.value = ''
  nameError.value = ''
  formTouched.value = false
}

const formatDate = (date: Date | string) => {
  return new Date(date).toLocaleDateString('es-ES', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  })
}

const truncateText = (text: string, maxLength: number) => {
  if (!text) return 'Sin información'
  return text.length > maxLength ? text.substring(0, maxLength) + '...' : text
}

const truncateId = (id: string) => {
  if (!id) return 'Sin ID'
  return id.length > 8 ? id.substring(0, 8) + '...' : id
}

const formatCoordinate = (value: number, type: 'lat' | 'lng') => {
  if (value === 0) return '-'
  const direction = type === 'lat' ? (value >= 0 ? 'N' : 'S') : (value >= 0 ? 'E' : 'W')
  return `${Math.abs(value).toFixed(6)}° ${direction}`
}

const getTypeUseColor = (typeUse: string) => {
  switch (typeUse?.toLowerCase()) {
    case 'industrial':
      return 'blue'
    case 'comercial':
      return 'green'
    case 'residencial':
      return 'orange'
    case 'agricola':
      return 'brown'
    case 'minero':
      return 'purple'
    case 'forestal':
      return 'teal'
    default:
      return 'grey'
  }
}

const showMetadata = (item: Locations) => {
  selectedMetadata.value = item.metadata || 'Sin metadatos disponibles'
  metadataDialog.value = true
}

const viewOnMap = (item: Locations) => {
  if (item.lat !== 0 && item.lng !== 0) {
    // Abrir en Google Maps
    const url = `https://www.google.com/maps?q=${item.lat},${item.lng}`
    window.open(url, '_blank')
  } else {
    console.log('La ubicación no tiene coordenadas válidas')
  }
}

// ─── EVENTOS / BOTONES ─────────────────────────────────────────────────────
const getLocations = async () => {
  loading.value = true
  try {
    await locationsStore.getLocations()
    locations.value = locationsStore.locations
  } catch (error) {
    activeAlert.value = true
    textAlert.value = 'Error al obtener las ubicaciones'
    colorAlert.value = 'error'
  }
  loading.value = false
}

const btnSetActiveCreateLocation = () => {
  activeCreateNewLocation.value = !activeCreateNewLocation.value
  location.value = new Locations()
  codeError.value = ''
  nameError.value = ''
}

const validateForm = (): boolean => {
  let isValid = true

  // Validación de campos obligatorios
  if (!location.value.code) {
    codeError.value = 'Código requerido'
    isValid = false
  } else {
    codeError.value = ''
  }

  if (!location.value.name) {
    nameError.value = 'Nombre requerido'
    isValid = false
  } else {
    nameError.value = ''
  }

  if (!isValid) {
    activeAlert.value = true
    textAlert.value = 'Todos los campos obligatorios deben ser completados'
    colorAlert.value = 'error'
  }

  return isValid
}

const btnSetActiveEditLocation = async (selectedLocation: Locations) => {
  location.value = new Locations(selectedLocation)
  activeEditLocation.value = true
}

const btnCreateLocation = async () => {
  formTouched.value = true

  const valid = await formRef.value?.validate()
  if (!valid.valid || !validateForm()) return

  loadingCreateLocation.value = true

  try {
    await locationsStore.postLocations(location.value)
    activeAlert.value = true
    textAlert.value = 'Ubicación creada exitosamente'
    colorAlert.value = 'success'
    activeCreateNewLocation.value = false
    getLocations()
  } catch (error) {
    activeAlert.value = true
    textAlert.value = 'Error al crear la ubicación'
    colorAlert.value = 'error'
  }

  loadingCreateLocation.value = false
}

const btnUpdateLocation = async () => {
  formTouched.value = true

  const valid = await formRef.value?.validate()
  if (!valid.valid || !validateForm()) return

  loadingEditLocation.value = true

  try {
    await locationsStore.putLocations(location.value)
    activeAlert.value = true
    textAlert.value = 'Ubicación actualizada exitosamente'
    colorAlert.value = 'success'
    activeEditLocation.value = false
    getLocations()
  } catch (error) {
    activeAlert.value = true
    textAlert.value = 'Error al actualizar la ubicación'
    colorAlert.value = 'error'
  }

  loadingEditLocation.value = false
}

const btnDeleteLocation = async (locationToDelete: Locations) => {
  if (confirm(`¿Está seguro de eliminar la ubicación "${locationToDelete.name}"?`)) {
    try {
      await locationsStore.deleteLocations(locationToDelete.id)
      activeAlert.value = true
      textAlert.value = 'Ubicación eliminada exitosamente'
      colorAlert.value = 'success'
      getLocations()
    } catch (error) {
      activeAlert.value = true
      textAlert.value = 'Error al eliminar la ubicación'
      colorAlert.value = 'error'
    }
  }
}

// ─── LIFECYCLE ─────────────────────────────────────────────────────────────
onMounted(async () => {
  // Cargar ubicaciones desde el store
  await getLocations()
})

return (_ctx: any,_cache: any) => {
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_pagination = _resolveComponent("v-pagination")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_v_card, {
    elevation: "0",
    class: "bg-background pa-5 rounded-lg"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_alert, {
        modelValue: activeAlert.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeAlert).value = $event)),
        type: colorAlert.value,
        dismissible: "",
        class: "mb-4"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(textAlert.value), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "type"]),
      (!activeCreateNewLocation.value && !activeEditLocation.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_v_card, {
              class: "mt-3 rounded-lg",
              elevation: "3"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_v_card_title, {
                    color: "primary",
                    class: "text-subtitle-4"
                  }, {
                    default: _withCtx(() => _cache[22] || (_cache[22] = [
                      _createTextVNode("Ubicaciones")
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_v_spacer),
                  (!activeCreateNewLocation.value && !activeEditLocation.value)
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 0,
                        onClick: btnSetActiveCreateLocation,
                        variant: "text",
                        text: "Nueva ubicación"
                      }))
                    : (_openBlock(), _createBlock(_component_v_btn, {
                        key: 1,
                        onClick: _cache[1] || (_cache[1] = ($event: any) => ((activeCreateNewLocation.value = false), (activeEditLocation.value = false))),
                        variant: "text",
                        text: "Volver a las ubicaciones"
                      }))
                ]),
                _createVNode(_component_v_text_field, {
                  modelValue: searchLocations.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchLocations).value = $event)),
                  "append-inner-icon": "mdi-magnify",
                  density: "compact",
                  label: "Buscar ubicación",
                  variant: "solo",
                  "hide-details": "",
                  "single-line": "",
                  color: "surface-light",
                  class: "mx-4",
                  "bg-color": "background"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_data_table, {
                  class: "rounded-lg text-body-2",
                  page: page.value,
                  "onUpdate:page": _cache[4] || (_cache[4] = ($event: any) => ((page).value = $event)),
                  headers: headers,
                  items: locationsList.value,
                  search: searchLocations.value,
                  loading: loading.value,
                  "items-per-page": itemsPerPage.value
                }, {
                  loading: _withCtx(() => [
                    _createVNode(_component_v_skeleton_loader, {
                      class: "bg-background",
                      type: "table-row@10"
                    })
                  ]),
                  [`item.code`]: _withCtx(({ item }) => [
                    _createVNode(_component_v_chip, {
                      color: "blue",
                      variant: "outlined",
                      small: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.code), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  [`item.name`]: _withCtx(({ item }) => [
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_v_avatar, {
                        size: "36",
                        class: "mr-3",
                        color: "primary"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_4, _toDisplayString(item.code?.substring(0, 2).toUpperCase()), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_5, _toDisplayString(item.name), 1),
                        _createElementVNode("div", _hoisted_6, _toDisplayString(item.code), 1)
                      ])
                    ])
                  ]),
                  [`item.extendedName`]: _withCtx(({ item }) => [
                    _createElementVNode("div", _hoisted_7, _toDisplayString(item.extendedName || 'N/A'), 1)
                  ]),
                  [`item.description`]: _withCtx(({ item }) => [
                    _createElementVNode("div", _hoisted_8, _toDisplayString(truncateText(item.description, 40)), 1)
                  ]),
                  [`item.typeUse`]: _withCtx(({ item }) => [
                    _createVNode(_component_v_chip, {
                      color: getTypeUseColor(item.typeUse),
                      variant: "outlined",
                      small: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.typeUse || 'Sin tipo'), 1)
                      ]),
                      _: 2
                    }, 1032, ["color"])
                  ]),
                  [`item.utm`]: _withCtx(({ item }) => [
                    _createElementVNode("span", _hoisted_9, _toDisplayString(item.utm || 'Sin UTM'), 1)
                  ]),
                  [`item.coordinates`]: _withCtx(({ item }) => [
                    _createElementVNode("div", _hoisted_10, [
                      (item.lat !== 0 || item.lng !== 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            _createElementVNode("span", _hoisted_12, _toDisplayString(formatCoordinate(item.lat, 'lat')), 1),
                            _cache[23] || (_cache[23] = _createElementVNode("br", null, null, -1)),
                            _createElementVNode("span", _hoisted_13, _toDisplayString(formatCoordinate(item.lng, 'lng')), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_14, "Sin coordenadas"))
                    ])
                  ]),
                  [`item.altitude`]: _withCtx(({ item }) => [
                    (item.altitude !== 0)
                      ? (_openBlock(), _createBlock(_component_v_chip, {
                          key: 0,
                          color: "green",
                          variant: "outlined",
                          small: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.altitude) + " m ", 1)
                          ]),
                          _: 2
                        }, 1024))
                      : (_openBlock(), _createElementBlock("span", _hoisted_15, "-"))
                  ]),
                  [`item.companyId`]: _withCtx(({ item }) => [
                    _createVNode(_component_v_chip, {
                      color: "purple",
                      variant: "outlined",
                      small: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.companyId), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  [`item.parentLocationId`]: _withCtx(({ item }) => [
                    (item.parentLocationId)
                      ? (_openBlock(), _createBlock(_component_v_chip, {
                          key: 0,
                          color: "orange",
                          variant: "outlined",
                          small: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(truncateId(item.parentLocationId)), 1)
                          ]),
                          _: 2
                        }, 1024))
                      : (_openBlock(), _createElementBlock("span", _hoisted_16, "Raíz"))
                  ]),
                  [`item.metadata`]: _withCtx(({ item }) => [
                    (item.metadata)
                      ? (_openBlock(), _createBlock(_component_v_icon, {
                          key: 0,
                          small: "",
                          color: "info",
                          onClick: ($event: any) => (showMetadata(item))
                        }, {
                          default: _withCtx(() => _cache[24] || (_cache[24] = [
                            _createTextVNode(" mdi-information ")
                          ])),
                          _: 2
                        }, 1032, ["onClick"]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_17, "-"))
                  ]),
                  [`item.createdAt`]: _withCtx(({ item }) => [
                    _createTextVNode(_toDisplayString(formatDate(item.createdAt)), 1)
                  ]),
                  [`item.createdBy`]: _withCtx(({ item }) => [
                    _createElementVNode("span", _hoisted_18, _toDisplayString(item.createdBy || 'Sistema'), 1)
                  ]),
                  [`item.actions`]: _withCtx(({ item }) => [
                    _createElementVNode("div", _hoisted_19, [
                      _withDirectives(_createVNode(_component_v_btn, {
                        variant: "text",
                        onClick: ($event: any) => (btnSetActiveEditLocation(item)),
                        icon: "mdi-pencil-outline"
                      }, null, 8, ["onClick"]), [
                        [_directive_tooltip, `Editar`]
                      ]),
                      _withDirectives(_createVNode(_component_v_btn, {
                        variant: "text",
                        onClick: ($event: any) => (viewOnMap(item)),
                        icon: "mdi-map-marker"
                      }, null, 8, ["onClick"]), [
                        [_directive_tooltip, `Ver en mapa`]
                      ]),
                      _withDirectives(_createVNode(_component_v_btn, {
                        variant: "text",
                        onClick: ($event: any) => (btnDeleteLocation(item)),
                        icon: "mdi-delete-outline",
                        color: "error"
                      }, null, 8, ["onClick"]), [
                        [_directive_tooltip, `Eliminar`]
                      ])
                    ])
                  ]),
                  bottom: _withCtx(() => [
                    _createElementVNode("div", _hoisted_20, [
                      _createVNode(_component_v_pagination, {
                        modelValue: page.value,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((page).value = $event)),
                        length: pageCount.value
                      }, null, 8, ["modelValue", "length"])
                    ])
                  ]),
                  _: 2
                }, 1032, ["page", "items", "search", "loading", "items-per-page"])
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (activeCreateNewLocation.value || activeEditLocation.value)
        ? (_openBlock(), _createBlock(_component_v_row, {
            key: 1,
            justify: "center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                md: "10",
                lg: "8"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    elevation: "4",
                    class: "bg-background pa-0 ma-0 rounded-lg content-container"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("span", _hoisted_22, _toDisplayString(activeCreateNewLocation.value ? 'Crear nueva ubicación' : 'Editar ubicación'), 1),
                        _createElementVNode("div", null, [
                          _createVNode(_component_v_btn, {
                            color: "red",
                            variant: "tonal",
                            class: "mr-2",
                            rounded: "lg",
                            onClick: resetForm
                          }, {
                            default: _withCtx(() => _cache[25] || (_cache[25] = [
                              _createTextVNode(" Limpiar ")
                            ])),
                            _: 1
                          }),
                          _createVNode(_component_v_btn, {
                            color: "primary",
                            variant: "tonal",
                            class: "mr-2",
                            rounded: "lg",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (activeCreateNewLocation.value = false, activeEditLocation.value = false))
                          }, {
                            default: _withCtx(() => _cache[26] || (_cache[26] = [
                              _createTextVNode(" Volver ")
                            ])),
                            _: 1
                          }),
                          _createVNode(_component_v_btn, {
                            color: "primary",
                            class: "text-white",
                            rounded: "lg",
                            loading: loadingCreateLocation.value || loadingEditLocation.value,
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (activeCreateNewLocation.value ? btnCreateLocation() : btnUpdateLocation()))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(activeCreateNewLocation.value ? 'Crear' : 'Actualizar'), 1)
                            ]),
                            _: 1
                          }, 8, ["loading"])
                        ])
                      ]),
                      _createVNode(_component_v_row, { justify: "center" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "12" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_sheet, {
                                color: "white",
                                class: "pa-6",
                                elevation: "0"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_form, {
                                    ref_key: "formRef",
                                    ref: formRef,
                                    modelValue: formValid.value,
                                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((formValid).value = $event)),
                                    "validate-on": "submit lazy"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_23, [
                                        _cache[27] || (_cache[27] = _createElementVNode("h4", { class: "text-h6 mb-6" }, "Información de la ubicación", -1)),
                                        _createVNode(_component_v_row, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, {
                                              cols: "12",
                                              md: "6",
                                              class: "mb-3"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_text_field, {
                                                  modelValue: location.value.code,
                                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((location.value.code) = $event)),
                                                  label: "Código *",
                                                  "error-messages": formTouched.value && codeError.value ? [codeError.value] : [],
                                                  variant: "outlined",
                                                  density: "comfortable",
                                                  "bg-color": "white",
                                                  hint: "Código único de la ubicación",
                                                  "persistent-hint": ""
                                                }, null, 8, ["modelValue", "error-messages"])
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "12",
                                              md: "6",
                                              class: "mb-3"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_text_field, {
                                                  modelValue: location.value.name,
                                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((location.value.name) = $event)),
                                                  label: "Nombre *",
                                                  "error-messages": formTouched.value && nameError.value ? [nameError.value] : [],
                                                  variant: "outlined",
                                                  density: "comfortable",
                                                  "bg-color": "white",
                                                  hint: "Nombre de la ubicación",
                                                  "persistent-hint": ""
                                                }, null, 8, ["modelValue", "error-messages"])
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "12",
                                              class: "mb-3"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_text_field, {
                                                  modelValue: location.value.extendedName,
                                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((location.value.extendedName) = $event)),
                                                  label: "Nombre extendido",
                                                  variant: "outlined",
                                                  density: "comfortable",
                                                  "bg-color": "white",
                                                  hint: "Nombre completo de la ubicación (opcional)",
                                                  "persistent-hint": ""
                                                }, null, 8, ["modelValue"])
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "12",
                                              class: "mb-3"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_textarea, {
                                                  modelValue: location.value.description,
                                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((location.value.description) = $event)),
                                                  label: "Descripción",
                                                  variant: "outlined",
                                                  density: "comfortable",
                                                  "bg-color": "white",
                                                  hint: "Descripción detallada de la ubicación",
                                                  "persistent-hint": "",
                                                  rows: "3"
                                                }, null, 8, ["modelValue"])
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "12",
                                              md: "6",
                                              class: "mb-3"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_text_field, {
                                                  modelValue: location.value.typeUse,
                                                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((location.value.typeUse) = $event)),
                                                  label: "Tipo de uso",
                                                  variant: "outlined",
                                                  density: "comfortable",
                                                  "bg-color": "white",
                                                  hint: "Tipo de uso de la ubicación",
                                                  "persistent-hint": ""
                                                }, null, 8, ["modelValue"])
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "12",
                                              md: "6",
                                              class: "mb-3"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_text_field, {
                                                  modelValue: location.value.utm,
                                                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((location.value.utm) = $event)),
                                                  label: "Coordenadas UTM",
                                                  variant: "outlined",
                                                  density: "comfortable",
                                                  "bg-color": "white",
                                                  hint: "Coordenadas UTM",
                                                  "persistent-hint": ""
                                                }, null, 8, ["modelValue"])
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "12",
                                              md: "4",
                                              class: "mb-3"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_text_field, {
                                                  modelValue: location.value.lat,
                                                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((location.value.lat) = $event)),
                                                  modelModifiers: { number: true },
                                                  label: "Latitud",
                                                  variant: "outlined",
                                                  density: "comfortable",
                                                  "bg-color": "white",
                                                  hint: "Latitud en grados decimales",
                                                  "persistent-hint": "",
                                                  type: "number",
                                                  step: "0.000001"
                                                }, null, 8, ["modelValue"])
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "12",
                                              md: "4",
                                              class: "mb-3"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_text_field, {
                                                  modelValue: location.value.lng,
                                                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((location.value.lng) = $event)),
                                                  modelModifiers: { number: true },
                                                  label: "Longitud",
                                                  variant: "outlined",
                                                  density: "comfortable",
                                                  "bg-color": "white",
                                                  hint: "Longitud en grados decimales",
                                                  "persistent-hint": "",
                                                  type: "number",
                                                  step: "0.000001"
                                                }, null, 8, ["modelValue"])
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "12",
                                              md: "4",
                                              class: "mb-3"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_text_field, {
                                                  modelValue: location.value.altitude,
                                                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((location.value.altitude) = $event)),
                                                  modelModifiers: { number: true },
                                                  label: "Altitud (m)",
                                                  variant: "outlined",
                                                  density: "comfortable",
                                                  "bg-color": "white",
                                                  hint: "Altitud en metros",
                                                  "persistent-hint": "",
                                                  type: "number",
                                                  step: "0.01"
                                                }, null, 8, ["modelValue"])
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "12",
                                              md: "6",
                                              class: "mb-3"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_text_field, {
                                                  modelValue: location.value.companyId,
                                                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((location.value.companyId) = $event)),
                                                  modelModifiers: { number: true },
                                                  label: "ID Empresa",
                                                  variant: "outlined",
                                                  density: "comfortable",
                                                  "bg-color": "white",
                                                  hint: "ID de la empresa asociada",
                                                  "persistent-hint": "",
                                                  type: "number"
                                                }, null, 8, ["modelValue"])
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "12",
                                              md: "6",
                                              class: "mb-3"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_text_field, {
                                                  modelValue: location.value.parentLocationId,
                                                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((location.value.parentLocationId) = $event)),
                                                  label: "ID Ubicación Padre",
                                                  variant: "outlined",
                                                  density: "comfortable",
                                                  "bg-color": "white",
                                                  hint: "ID de la ubicación padre (opcional)",
                                                  "persistent-hint": ""
                                                }, null, 8, ["modelValue"])
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "12",
                                              class: "mb-3"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_textarea, {
                                                  modelValue: location.value.metadata,
                                                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((location.value.metadata) = $event)),
                                                  label: "Metadatos",
                                                  variant: "outlined",
                                                  density: "comfortable",
                                                  "bg-color": "white",
                                                  hint: "Metadatos adicionales en formato JSON",
                                                  "persistent-hint": "",
                                                  rows: "3"
                                                }, null, 8, ["modelValue"])
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        _cache[28] || (_cache[28] = _createElementVNode("div", { class: "text-caption text-medium-emphasis mt-4" }, " * Campos obligatorios ", -1))
                                      ])
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_v_dialog, {
        modelValue: metadataDialog.value,
        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((metadataDialog).value = $event)),
        "max-width": "600px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, null, {
                default: _withCtx(() => _cache[29] || (_cache[29] = [
                  _createElementVNode("span", { class: "text-h5" }, "Metadatos de Ubicación", -1)
                ])),
                _: 1
              }),
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _createElementVNode("pre", _hoisted_24, _toDisplayString(selectedMetadata.value), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_actions, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_v_btn, {
                    color: "blue darken-1",
                    text: "",
                    onClick: _cache[20] || (_cache[20] = ($event: any) => (metadataDialog.value = false))
                  }, {
                    default: _withCtx(() => _cache[30] || (_cache[30] = [
                      _createTextVNode(" Cerrar ")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}
}

})